export default function Carousel(container) {
    let blocked = false;
    this.container = container;
    let clone;
    let elements = [].map.call(container.querySelectorAll('li.item'), (el) => el);
    this.elementsCount = elements.length;
    this.current = Math.ceil(this.elementsCount / 2);
    const self = this;

    this.next = () => {
        const currentEl = container.querySelector('li.item.current');
        elements[self.current].classList.add('current');
        currentEl.classList.remove('current');
        const previous = self.current;

        duplicateFirstElement();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcPositions(previous, 1);
            });
        });
        blocked = true;
        setTimeout(() => {
            removeClone();
            blocked = false;
        }, 300);
    };
    this.prev = () => {
        const currentEl = container.querySelector('li.item.current');
        elements[self.current - 2].classList.add('current');
        currentEl.classList.remove('current');
        const previous = self.current;

        duplicateLastElement();
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                recalcPositions(previous, -1);
            });
        });
        blocked = true;
        setTimeout(() => {
            removeClone();
            blocked = false;
        }, 300);
    };

    const recalcPositions = (from, direction) => {
        elements.concat([clone]).forEach((element) => {
            element.style.setProperty('--offset', element.style.getPropertyValue('--offset') * 1 - direction);
        });
    };
    const removeClone = () => {
        clone.parent.style.setProperty('--offset', clone.style.getPropertyValue('--offset') * 1);
        clone.parentElement.replaceChild(clone.parent, clone);

        elements = [].map.call(container.querySelectorAll('li.item'), (el) => el);
    };

    const duplicateLastElement = () => {
        clone = elements[elements.length - 1].cloneNode(true);
        // offset z lewej
        clone.style.setProperty('--offset', - elements.length + 2);
        clone.classList.remove('current');
        clone.parent = elements[elements.length - 1];
        self.container.prepend(clone);
    };
    const duplicateFirstElement = () => {
        clone = elements[0].cloneNode(true);
        // offset z prawej
        clone.style.setProperty('--offset', elements.length - 1);
        clone.classList.remove('current');
        clone.parent = elements[0];
        self.container.append(clone);
    };

    elements.forEach((element, i) => {
        element.style.setProperty('--offset', i - self.current + 1);
        if (element.querySelector('.prev')) {
            element.querySelector('.prev').addEventListener('click', (e) => {
                e.preventDefault();
                if (!blocked) {
                    self.prev();
                }
            });
        }
        if (element.querySelector('.next')) {
            element.querySelector('.next').addEventListener('click', (e) => {
                e.preventDefault();
                if (!blocked) {
                    self.next();
                }
            });
        }
    });
}